import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})
export class OdsV2Service {

  constructor(
    private http: HttpClient
  ) { }

  getInstitutos() {
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.ods.getInstituteArray);
  }

  getInstitutosV2(nivel:any,instituto:any) {
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.ods.getInstituteArrayV2+nivel+'/'+instituto);
  }

  getRegiones(datos?:any) {
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.ods.getRegiones, datos);
  }

  getCatPaises(numInstituto:any, idioma:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.avanceEncuesta.catPaises + numInstituto + "/" + idioma);
  }

  getPaisesBroker(broker:string){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.getPaisesBroker + broker);
  }

  getSectorarray() {
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.ods.getSectorarray);
  }

  registraEmpresa(datos:any){
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.empresas, datos);
  }

  actualizaEmpresa(idEmpresa:string, datos:any) {
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.ods.updateODS + idEmpresa,  datos);
  }

  getDatosEmpresa(idEmpresa: string) {
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.empresas + idEmpresa);
  }

  getSectoresV2(broker:any,lang:any){
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.getSectoresNuevo + broker+'/'+lang);
  }
  getSubSectoresV2(broker:any,lang:any,sectorId:any){
      return this.http.get(DATOS_API.url + DATOS_API.endpoints.getSubSectoresNuevo + broker+'/'+lang+'/'+sectorId);
  }
}
